// UI Text and Messages
export const UI_TEXT = {
  // Greetings
  greetings: {
    student: '👋 Welcome back',
    tutor: '🎓 Hello',
    defaultStudent: 'Student',
    defaultTutor: 'Tutor',
  },
  
  // Column titles
  columnTitles: {
    learningOverview: 'Learning Overview',
    businessOverview: 'Business Overview',
    quickSearch: 'Quick Search',
    myClasses: 'My Classes',
    upcomingClasses: 'Upcoming Classes',
    allClasses: 'All Classes',
    classCalendar: 'Class Calendar',
    myCourses: 'My Courses',
    todaySchedule: 'Today\'s Schedule',
  },
  
  // Section titles
  sectionTitles: {
    availableClasses: 'Available Classes',
    popularSubjects: 'Popular Subjects',
    searchResults: 'Search Results',
  },
  
  // Stat labels
  statLabels: {
    availableClasses: 'Available Classes',
    subjects: 'Subjects',
    avgPrice: 'Avg. Price',
    enrolled: 'Enrolled',
    totalClasses: 'Total Classes',
    upcoming: 'Upcoming',
    activeCourses: 'Active Courses',
    draft: 'Draft',
  },
  
  // Empty states
  emptyStates: {
    noClasses: {
      icon: '📚',
      title: 'No classes available',
      subtitle: 'Check back later for new classes!',
    },
    noUpcomingClasses: {
      icon: '📅',
      title: 'No upcoming classes',
      subtitle: 'Your upcoming classes will appear here',
    },
    noEnrolledClasses: {
      icon: '🎓',
      title: 'No classes yet',
      subtitle: 'Your enrolled classes will appear here',
    },
    noCourses: {
      icon: '📚',
      title: 'No courses yet',
      subtitle: 'Create your first course to start teaching!',
    },
    noSearchResults: {
      icon: '🔍',
      title: 'No results found',
      subtitle: 'Try adjusting your search criteria',
    },
    noTodaySchedule: {
      icon: '🗓️',
      title: 'No classes scheduled for today',
      subtitle: 'Take a break or plan your next class!',
    },
  },
  
  // Error messages
  errors: {
    loadClassesFailed: 'Failed to load classes. Please try again later.',
    loadCoursesFailed: 'Failed to load courses. Please try again later.',
    searchFailed: 'Search failed. Please try again.',
    adminApprovalPending: 'Admin approval pending!',
  },
  
  // Button text
  buttons: {
    viewAll: 'View All',
    showMore: 'Show More',
    showLess: 'Show Less',
    addNewCourse: '+ Add New Course',
    browseAllClasses: 'Browse All Classes',
    viewMySchedule: 'View My Schedule',
    advancedSearch: 'Advanced Search with Filters',
    backToLogin: 'Back to login',
    search: 'Search',
    close: '×',
  },
  
  // Placeholders
  placeholders: {
    search: 'Search classes, subjects, or tutors...',
    noSessionsScheduled: 'No sessions scheduled for',
  },
  
  // Status text
  status: {
    upcoming: 'upcoming' as const,
    completed: 'completed' as const,
    cancelled: 'cancelled' as const,
    tbd: 'TBD' as const,
  },
  
  // Calendar text
  calendar: {
    sessionsOn: 'Sessions on',
    today: 'Today',
    week: 'Week',
    month: 'Month',
  },
  
  // Search text
  search: {
    viewAllResults: 'View All Results',
    advancedSearchIcon: '⚙️',
  },
  
  // Icons
  icons: {
    wave: '👋',
    chart: '📊',
    search: '🔍',
    calendar: '📅',
    book: '📚',
    graduation: '🎓',
    clock: '⏰',
    settings: '⚙️',
    arrow: '→',
    chevronLeft: '‹',
    chevronRight: '›',
    plus: '+',
    minus: '−',
    online: '🌐',
    inPerson: '📍',
  },
  
  // Location types
  locationTypes: {
    online: 'Online',
    inPerson: 'In-Person',
    onlineWithIcon: '🌐 Online',
    inPersonWithIcon: '📍 In-Person',
  },
  
  // Field labels
  fieldLabels: {
    meetingLink: 'Meeting Link',
    location: 'Location',
    googleMeetLink: 'Google Meet Link',
    physicalAddress: 'Physical Address',
    joinGoogleMeet: 'Join Google Meet',
  },
};

// Helper function to get empty state by type
export const getEmptyState = (type: keyof typeof UI_TEXT.emptyStates) => {
  return UI_TEXT.emptyStates[type];
};

// Helper function to format greeting
export const formatGreeting = (userType: 'student' | 'tutor', firstName?: string) => {
  const greeting = UI_TEXT.greetings[userType];
  const defaultName = userType === 'student' ? UI_TEXT.greetings.defaultStudent : UI_TEXT.greetings.defaultTutor;
  return `${greeting}, ${firstName || defaultName}`;
};